// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.RoleSetup.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import RoleList from './MiddlePanel/Izenda.RoleList';
import RoleDetail from './RoleDetail/Izenda.RoleDetail';
import MiddlePanel from 'share/components/layout/Izenda.MiddlePanel';
import Header from './MiddlePanel/Izenda.RoleListHeader';
import ScrollBox from 'share/components/controls/Izenda.ScrollBox';
import action from './Izenda.RoleSetupAction';
import MainContent from 'share/components/layout/Izenda.MainContent';
import connect from 'share/enhancers/Izenda.Connect';

@connect(action)
export default class RoleSetup extends Component {
  componentDidMount() {
    this.props.loadData();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.store !== nextProps.store) {
      nextProps.loadData();
    }
  }

  componentWillUnmount() {
    this.props.disposeChangeTenant();
    this.props.store.destroy();
  }

  render() {
    const { store, authorization, authorizationConstants: { PERMISSION_KEY } } = this.props;
    const isNew = store.roleDetail.isNew;
    const allowCreate = authorization.checkPrivileges([PERMISSION_KEY.RoleSetupActionsCreate]);
    const allowEdit = authorization.checkPrivileges([PERMISSION_KEY.RoleSetupActionsEdit]);

    return (
      <div className="izenda-TableLayout">
        <MiddlePanel>
          <div className="u_fullHeight u-posRelative u-bgWhite izenda-Middle-section">
            <div className="izenda-MiddlePanel-search">
              <Header store={store} readOnly={!allowCreate} />
            </div>

            <div className="izenda-MiddlePanel-content">
              <ScrollBox>
                <RoleList store={store} readOnly={!allowEdit} />
              </ScrollBox>
            </div>
          </div>
        </MiddlePanel>

        <MainContent>
          <RoleDetail store={store} readOnly={!(allowEdit || isNew)} />
        </MainContent>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/RoleSetup/Izenda.RoleSetup.jsx